import { GetScoreClientResponse, PostScoreClientResponse } from '../services/amazingScoring/amazingScoring.types';
import { formDataToArrangeOkb } from '../store/adapters/formStore';
import { provider } from './client';

export const setScoringTask = async (
    formData: FE.FormData,
    userId?: string,
): Promise<PostScoreClientResponse | null> => {
    const scoringData = formDataToArrangeOkb(formData);
    return await provider.postScoringData(scoringData, userId).catch(() => null);
};

export const loadScoring = async (taskId: string): Promise<GetScoreClientResponse | null> => {
    return await provider.checkScoringData(taskId).catch(() => null);
};
